import { useCallback } from 'react';
import { useAdvertiser } from '../../AdvertiserContext';
import { APIBusinessReferral } from '../../api_business_auth';
import ReferralBlock from './ReferralBlock';

export default function BusinessReferralCard() {
  const { advertiserToken } = useAdvertiser();
  const fetcher = useCallback(() => APIBusinessReferral(advertiserToken), [advertiserToken]);
  if (!advertiserToken) return null;
  return <ReferralBlock fetcher={fetcher} />;
}